import { AlreadyRegisteredError } from './errors.js';
import assert from 'minimalistic-assert';
import { CONTAINER_ID } from './utils.js';
export default class Registry {
    #nodes = new Map();
    set({ id, entry, override = false }) {
        if (this.#nodes.has(id) && !override) {
            throw new AlreadyRegisteredError(id);
        }
        this.#nodes.set(id, entry);
    }
    get(id) {
        return this.#nodes.get(id);
    }
    setInstance({ id, instance }) {
        const node = this.#nodes.get(id);
        node.instance = instance;
    }
    getInstance({ id, parent, }) {
        const node = this.#nodes.get(id);
        if (!node) {
            return;
        }
        assert(!node.private ||
            !node.namespace ||
            node.namespace === parent.namespace ||
            parent.id === CONTAINER_ID, `Requested private dependency "${id}" in namespace "${node.namespace}" from "${parent.id.toString()}" in namespace "${parent.namespace}"`);
        return node.instance;
    }
    nodes() {
        return this.#nodes.values();
    }
}
